import {
  Bold,
  Code,
  Italic,
  Strikethrough,
  Subscript,
  Superscript,
  Underline
} from "@ckeditor/ckeditor5-basic-styles";
import { BlockQuote } from "@ckeditor/ckeditor5-block-quote";
import { CloudServices } from "@ckeditor/ckeditor5-cloud-services";
import { CodeBlock } from "@ckeditor/ckeditor5-code-block";

import { Essentials } from "@ckeditor/ckeditor5-essentials";
import { FindAndReplace } from "@ckeditor/ckeditor5-find-and-replace";
import {
  // FontBackgroundColor,
  // FontColor,
  FontFamily,
  FontSize
} from "@ckeditor/ckeditor5-font";
import { Heading } from "@ckeditor/ckeditor5-heading";
// import { Highlight } from "@ckeditor/ckeditor5-highlight";
import { HorizontalLine } from "@ckeditor/ckeditor5-horizontal-line";
import { HtmlEmbed } from "@ckeditor/ckeditor5-html-embed";
import {
  DataFilter,
  DataSchema,
  GeneralHtmlSupport,
  HtmlComment
} from "@ckeditor/ckeditor5-html-support";
import {
  AutoImage,
  Image,
  ImageCaption,
  ImageInsert,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  ImageUpload
} from "@ckeditor/ckeditor5-image";
import { Indent, IndentBlock } from "@ckeditor/ckeditor5-indent";
import { TextPartLanguage } from "@ckeditor/ckeditor5-language";
import { AutoLink, Link, LinkImage } from "@ckeditor/ckeditor5-link";
import { List, ListProperties, TodoList } from "@ckeditor/ckeditor5-list";
import { MediaEmbed, MediaEmbedToolbar } from "@ckeditor/ckeditor5-media-embed";
import { Mention } from "@ckeditor/ckeditor5-mention";
import { Paragraph } from "@ckeditor/ckeditor5-paragraph";

import { RemoveFormat } from "@ckeditor/ckeditor5-remove-format";
import { StandardEditingMode } from "@ckeditor/ckeditor5-restricted-editing";
import { SourceEditing } from "@ckeditor/ckeditor5-source-editing";
import {
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText
} from "@ckeditor/ckeditor5-special-characters";
import {
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar
} from "@ckeditor/ckeditor5-table";
import { WordCount } from "@ckeditor/ckeditor5-word-count";
import ResizableHeight from "@pikulinpw/ckeditor5-resizableheight";
import { Alignment } from "@ckeditor/ckeditor5-alignment";
import { Autosave } from "@ckeditor/ckeditor5-autosave";

// import TextTransformation from "@ckeditor/ckeditor5-typing/src/texttransformation";

import AddBlankButton from "./AddBlankButton";

// const customColorPalette = [
//   {
//     color: "hsl(4, 90%, 58%)",
//     label: "Red",
//   },
//   {
//     color: "hsl(340, 82%, 52%)",
//     label: "Pink",
//   },
//   {
//     color: "hsl(291, 64%, 42%)",
//     label: "Purple",
//   },
//   {
//     color: "hsl(262, 52%, 47%)",
//     label: "Deep Purple",
//   },
//   {
//     color: "hsl(231, 48%, 48%)",
//     label: "Indigo",
//   },
//   {
//     color: "hsl(207, 90%, 54%)",
//     label: "Blue",
//   },

//   // More colors.
//   // ...
// ];

const customColorPaletteForFont = [
  { color: "#3B82F6", label: "Sky Blue" },
  { color: "#10B981", label: "Emerald Green" },
  { color: "#F59E0B", label: "Amber/Goldenrod" },
  { color: "#EF4444", label: "Rose/Coral Red" }
];

const customColorPaletteForBackground = [
  { color: "#DBEAFE", label: "Light Blue" },
  { color: "#D1FAE5", label: "Mint Green" },
  { color: "#FEF9C3", label: "Lemon Yellow" },
  { color: "#FEE2E2", label: "Blush Red" }
];

export const generatorConfiguration = (isMultimediaRequired: boolean) => {
  const plugins = [
    Alignment,
    AutoImage,
    AutoLink,
    Autosave,
    BlockQuote,
    Bold,
    CloudServices,
    Code,
    CodeBlock,
    DataFilter,
    DataSchema,
    Essentials,
    FindAndReplace,
    // FontBackgroundColor,
    // FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    // Highlight,
    HorizontalLine,
    HtmlComment,
    HtmlEmbed,
    Image,
    ImageCaption,
    ImageInsert,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    ListProperties,
    Mention,
    Paragraph,
    RemoveFormat,
    ResizableHeight,
    SourceEditing,
    SpecialCharacters,
    SpecialCharactersArrows,
    SpecialCharactersCurrency,
    SpecialCharactersEssentials,
    SpecialCharactersLatin,
    SpecialCharactersMathematical,
    SpecialCharactersText,
    StandardEditingMode,
    Strikethrough,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextPartLanguage,
    TodoList,
    Underline,
    WordCount
  ];
  const toolbar = {
    items: [
      "undo",
      "redo",
      "|",
      "|",
      "code",
      "codeBlock",
      "|",
      "fontfamily",
      "fontsize",
      // "fontColor",
      // "fontBackgroundColor",
      "|",
      "bold",
      "italic",
      "strikethrough",
      "subscript",
      "superscript",
      "-",
      "|",
      "alignment",
      "link",
      "uploadImage",
      // "videoUpload",
      "audioUpload",
      "textFileReader",
      "sourceEditing",
      "blockQuote",
      "|",
      "bulletedList",
      "numberedList",
      "todoList",
      "outdent",
      "indent"
    ],
    shouldNotGroupWhenFull: false
  };
  const multimediaPlugins = [MediaEmbed, MediaEmbedToolbar];
  if (isMultimediaRequired) {
    const imageIndex = toolbar.items.indexOf("audioUpload");
    if (imageIndex !== -1) {
      toolbar.items.splice(imageIndex + 1, 0, "mediaEmbed");
    } else {
      toolbar.items.push("mediaEmbed");
    }
  }
  // if (isMultimediaRequired) {
  //   toolbar.items.push('mediaEmbed');
  // }
  return {
    plugins: isMultimediaRequired
      ? [...plugins, ...multimediaPlugins]
      : plugins,

    toolbar: {
      items: toolbar.items
    },
    mediaEmbed: {
      previewsInData: true,
      providers: [
        {
          name: "googleDrive",
          url: /^https:\/\/drive\.google\.com\/file\/d\/([^/]+)\//,
          html: (match: any) => {
            const id = match[1];
            return `<iframe 
             src="https://drive.google.com/file/d/${id}/preview"
             width="640" 
             height="480" 
             allowfullscreen>
           </iframe>`;
          }
        },
        {
          name: "youtube",
          url: /^https:\/\/www\.youtube\.com\/watch\?v=([^&]+)/,
          html: (match: any) => {
            const id = match[1];
            return `<iframe 
             src="https://www.youtube.com/embed/${id}?rel=0"
             width="640" 
             height="480" 
             >
           </iframe>`;
          }
        },
        {
          name: "vimeo",
          url: /^https:\/\/vimeo\.com\/(\d+)/,
          html: (match: any) => {
            const id = match[1];
            return `<iframe 
             src="https://player.vimeo.com/video/${id}"
             width="640" 
             height="480" 
             >
           </iframe>`;
          }
        },
        {
          name: "mp3",
          url: /^https?:\/\/[^\s$.?#].[^\s]*\.(mp3|wav|ogg|flac|aac|m4a|opus)(?:\?[^\s]*)?$/i,
          html: (match: any) => {
            const url = match[0];
            return (
              '<div style="position: relative; padding-top: 10px; width:100%; padding-bottom: 10px;">' +
              `<audio controls style="display:block;">` +
              `<source src="${url}" type="audio/mpeg">` +
              "Your browser does not support the audio element." +
              "</audio>" +
              "</div>"
            );
          }
        },
        {
          name: "mp4",
          url: /^https?:\/\/[^\s$.?#].[^\s]*\.(mp4|webm|ogg|mov|m4v|m3u8)(?:\?[^\s]*)?$/i,
          html: (match: any) => {
            const url = match[0];
            return (
              '<div style="display: flex; justify-content: center; width: 100%; padding: 10px 0;">' +
              '<div style="width: 100%; max-width: 640px;">' +
              `<video controls style="width: 100%; height: auto; display: block;">` +
              `<source src="${url}" type="video/mp4">` +
              "Your browser does not support the video element." +
              "</video>" +
              "</div>" +
              "</div>"
            );
          }
        }
      ]
    },

    ResizableHeight: {
      resize: true,
      minHeight: "500px"
    },
    // fontColor: {
    //   colors: customColorPaletteForFont,
    //   columns: 4,
    //   colorPicker: false
    // },
    // fontBackgroundColor: {
    //   colors: customColorPaletteForBackground,
    //   columns: 4,
    //   colorPicker: false
    // },

    language: "en",
    image: {
      toolbar: [
        "imageTextAlternative",
        "toggleImageCaption",
        "imageStyle:inline",
        "imageStyle:block",
        "imageStyle:side",
        "linkImage",
        "resizeImage"
      ]
    },
    table: {
      contentToolbar: [
        "tableColumn",
        "tableRow",
        "mergeTableCells",
        "tableCellProperties",
        "tableProperties"
      ],
      // Set the palettes for tables.
      tableProperties: {
        borderColors: customColorPaletteForFont,
        backgroundColors: customColorPaletteForBackground,
        colorPicker: false
      },

      // Set the palettes for table cells.
      tableCellProperties: {
        borderColors: customColorPaletteForFont,
        backgroundColors: customColorPaletteForBackground,
        colorPicker: false
      }
    },
    htmlEmbed: {
      showPreviews: true
    },
    htmlSupport: {
      allow: [
        {
          name: "audio",
          attributes: true,
          classes: true,
          styles: true
        },
        {
          name: "video",
          attributes: true,
          classes: true,
          styles: true
        },
        {
          name: "text",
          attributes: true,
          classes: true,
          styles: true
        },
        {
          name: "source",
          attributes: true
        },
        {
          name: "iframe",
          attributes: true,
          classes: true,
          styles: true
        }
      ]
    }
  };
};

export const editorConfiguration = {
  mediaEmbed: {
    previewsInData: true
  },
  plugins: [
    Alignment,
    AutoImage,
    AutoLink,
    Autosave,
    BlockQuote,
    Bold,
    CloudServices,
    Code,
    CodeBlock,
    DataFilter,
    DataSchema,
    Essentials,
    FindAndReplace,
    // FontBackgroundColor,
    // FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    // Highlight,
    HorizontalLine,
    HtmlComment,
    HtmlEmbed,
    Image,
    ImageCaption,
    ImageInsert,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    ListProperties,
    MediaEmbed,
    MediaEmbedToolbar,
    Mention,
    Paragraph,
    RemoveFormat,
    ResizableHeight,
    SourceEditing,
    SpecialCharacters,
    SpecialCharactersArrows,
    SpecialCharactersCurrency,
    SpecialCharactersEssentials,
    SpecialCharactersLatin,
    SpecialCharactersMathematical,
    SpecialCharactersText,
    StandardEditingMode,
    Strikethrough,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextPartLanguage,
    TodoList,
    Underline,
    WordCount,
    AddBlankButton
  ],
  ResizableHeight: {
    resize: true,
    minHeight: "250px",
    maxHeight: "350px"
  },
  // fontColor: {
  //   colors: customColorPaletteForFont,
  //   columns: 4,
  //   colorPicker: false
  // },
  // fontBackgroundColor: {
  //   colors: customColorPaletteForBackground,
  //   columns: 4,
  //   colorPicker: false
  // },
  toolbar: {
    items: [
      "heading",
      "|",
      {
        label: "Basic Styles",
        icon: "text",
        items: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "superscript",
          "subscript"
        ]
      },
      "|",
      "alignment",
      "bulletedList",
      "numberedList",
      "blockQuote",
      "|",
      {
        label: "Fonts",
        icon: "text",
        withText: true,
        // items: ["fontColor", "fontBackgroundColor", "fontFamily", "fontSize"]
        items: ["fontFamily", "fontSize"]
      },
      "|",
      {
        label: "Insert",
        icon: "plus",
        items: [
          "imageUpload",
          "audioUpload",
          "videoUpload",
          "textFileReader",
          "mediaEmbed",
          "imageInsert",
          "sourceEditing",
          "insertTable"
        ]
      },
      "|",
      "link",
      "outdent",
      "indent",
      "redo",
      "code",
      "codeBlock",
      "findAndReplace",
      // "highlight",
      "horizontalLine",
      "htmlEmbed",
      "pageBreak",
      "removeFormat",
      "sourceEditing"
    ]
  },
  language: "en",
  image: {
    toolbar: [
      "imageTextAlternative",
      "toggleImageCaption",
      "imageStyle:inline",
      "imageStyle:block",
      "imageStyle:side",
      "linkImage",
      "resizeImage"
    ]
  },
  table: {
    contentToolbar: [
      "tableColumn",
      "tableRow",
      "mergeTableCells",
      "tableCellProperties",
      "tableProperties"
    ],
    // Set the palettes for tables.
    tableProperties: {
      borderColors: customColorPaletteForFont,
      backgroundColors: customColorPaletteForBackground,
      colorPicker: false
    },

    // Set the palettes for table cells.
    tableCellProperties: {
      borderColors: customColorPaletteForFont,
      backgroundColors: customColorPaletteForBackground,
      colorPicker: false
    }
  },
  htmlEmbed: {
    showPreviews: true
  },
  htmlSupport: {
    allow: [
      {
        name: "audio",
        attributes: true,
        classes: true,
        styles: true
      },
      {
        name: "video",
        attributes: true,
        classes: true,
        styles: true
      },
      {
        name: "text",
        attributes: true,
        classes: true,
        styles: true
      },
      {
        name: "source",
        attributes: true
      },
      {
        name: "iframe",
        attributes: true,
        classes: true,
        styles: true
      }
    ]
  }
};

// using when need to preview output on same screen (quiz authoring)
